import { z } from "zod";

const fileSchema = z.object({
  file: z
    .instanceof(File, { message: "File is required" })
    .refine((file) => file.type === "text/csv", {
      message: "Only CSV files are allowed",
    }),
});

const NonWorkingDaySchema = z.object({
  date: z.coerce.date(), // Ensures valid YYYY-MM-DD format
  reason: z.string().optional(),
});
const DependencySchema = z.object({
  dependency: z.string().optional(),
});


const TaskSchema = z.object({
  taskName: z.string(),
  duration: z.number().int().positive(),
  predecessorsList:z.string().array().optional(),
  milestone:z.boolean().default(false)
});

const ProjectPhaseSchema = z.object({
  phaseName: z.string(),
  tasks: z.array(TaskSchema),
});

const ProjectDataSchema = z.object({
  projectStartDate:z.coerce.date(),
  project_name:z.string(),
  phases: z.array(ProjectPhaseSchema),
  dependencies: z.array(DependencySchema).optional(),
  nonWorkingDays: z.array(NonWorkingDaySchema),
  file: fileSchema.optional(),
});

export { ProjectDataSchema };
